/* variant-gallery-filter.js
 * Filters the product media gallery so only the images matching the
 * currently selected Color option are shown - main slider, desktop grid,
 * pagination dots and the zoom-dialog thumbnails.
 *
 * Convention: every product image alt text ends with " - <Color>",
 * e.g. "Blue Point Oyster Co. oyster illustration t-shirt - True Navy".
 *
 * If the selected colour has no matching images the full gallery is shown
 * rather than an empty one. Never throws; does nothing off product pages.
 */
(function () {
  'use strict';

  var DELIM = ' - ';
  var SLIDES = 'slideshow-slides > slideshow-slide';
  var GROUPS = [
    SLIDES,
    '.media-gallery__grid > li',
    '.dialog-thumbnails-list__thumbnail'
  ];
  var DOTS = '.slideshow-controls__dots > li';

  function colorFromAlt(alt) {
    if (!alt) return '';
    var i = alt.lastIndexOf(DELIM);
    if (i === -1) return '';
    return alt.slice(i + DELIM.length).trim().toLowerCase();
  }

  function selectedColor(scope) {
    var sets = scope.querySelectorAll('fieldset');
    for (var i = 0; i < sets.length; i++) {
      var legend = sets[i].querySelector('legend');
      if (!legend || !/colou?r/i.test(legend.textContent)) continue;
      var checked = sets[i].querySelector('input:checked');
      if (checked && checked.value) return checked.value.trim().toLowerCase();
      var sel = sets[i].querySelector('select');
      if (sel && sel.value) return sel.value.trim().toLowerCase();
    }
    var radio = scope.querySelector('input[type="radio"][name^="Color"]:checked, input[type="radio"][name^="color"]:checked');
    return radio && radio.value ? radio.value.trim().toLowerCase() : '';
  }

  function resetSlider(gallery) {
    var slides = gallery.querySelectorAll(SLIDES);
    var idx = -1;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].style.display !== 'none') { idx = i; break; }
    }
    if (idx < 0) return;
    var comp = gallery.querySelector('slideshow-component');
    if (comp && typeof comp.select === 'function') { try { comp.select(idx); } catch (e) {} }
    var track = gallery.querySelector('slideshow-slides');
    if (track && track.scrollTo) { try { track.scrollTo({ left: 0, top: 0, behavior: 'auto' }); } catch (e) {} }
  }

  function apply(gallery) {
    var scope = gallery.closest('.shopify-section') || document;
    var color = selectedColor(scope);
    var slideFlags = null;

    for (var g = 0; g < GROUPS.length; g++) {
      var items = gallery.querySelectorAll(GROUPS[g]);
      if (!items.length) continue;

      var flags = [], matches = 0, tagged = 0;
      for (var i = 0; i < items.length; i++) {
        var img = items[i].querySelector('img');
        var c = colorFromAlt(img && img.alt);
        if (c) tagged++;
        var ok = !!(color && c === color);
        flags.push(ok);
        if (ok) matches++;
      }

      // Only filter when the alt text is tagged AND something matches,
      // otherwise leave the gallery completely untouched.
      var filtering = !!color && tagged > 0 && matches > 0;
      for (var j = 0; j < items.length; j++) {
        items[j].style.display = (!filtering || flags[j]) ? '' : 'none';
      }
      if (GROUPS[g] === SLIDES) { slideFlags = filtering ? flags : null; }
    }

    // Pagination dots map 1:1 onto the slides.
    var dots = gallery.querySelectorAll(DOTS);
    if (dots.length && (!slideFlags || dots.length === slideFlags.length)) {
      for (var d = 0; d < dots.length; d++) {
        dots[d].style.display = (!slideFlags || slideFlags[d]) ? '' : 'none';
      }
    }

    resetSlider(gallery);
  }

  function run() {
    try {
      var galleries = document.querySelectorAll('media-gallery');
      for (var i = 0; i < galleries.length; i++) { apply(galleries[i]); }
    } catch (e) { /* never break the storefront */ }
  }

  var timer = null;
  function schedule() {
    if (timer) { clearTimeout(timer); }
    timer = setTimeout(function () { timer = null; run(); }, 80);
  }

  function init() {
    try {
      if (!document.querySelector('media-gallery')) return; // not a product page
      run();
      document.addEventListener('change', schedule, true);
      document.addEventListener('shopify:product:select', schedule, true);
      document.addEventListener('variant:update', schedule, true);
      // Horizon re-renders the product section on variant change.
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
